import { BaseApi } from './_base.api'
import { IGmailOAuthStatus, IMicrosoftOAuthStatus } from '@typings'
import { NEW_ENDPOINTS } from '@constants'

export class OAuthApi extends BaseApi {
  // Gmail OAuth
  // Get Gmail authorization URL
  getGmailAuthUrl = () =>
    this.api
      .get<{ auth_url: string }>(NEW_ENDPOINTS.OAUTH.GMAIL.AUTHORIZE)
      .then(res => res.data.auth_url)

  // Get Gmail connection status
  getGmailStatus = () =>
    this.api
      .get<IGmailOAuthStatus>(NEW_ENDPOINTS.OAUTH.GMAIL.STATUS)
      .then(res => res.data)

  // Disconnect Gmail
  disconnectGmail = () =>
    this.api
      .delete(NEW_ENDPOINTS.OAUTH.GMAIL.DISCONNECT)
      .then(res => res.data)

  // Microsoft OAuth
  // Get Microsoft authorization URL
  getMicrosoftAuthUrl = () =>
    this.api
      .get<{ auth_url: string }>(NEW_ENDPOINTS.OAUTH.MICROSOFT.REDIRECT)
      .then(res => res.data.auth_url)

  // Get Microsoft connection status
  getMicrosoftStatus = () =>
    this.api
      .get<IMicrosoftOAuthStatus>(NEW_ENDPOINTS.OAUTH.MICROSOFT.STATUS)
      .then(res => res.data)

  // Disconnect Microsoft
  disconnectMicrosoft = () =>
    this.api
      .delete(NEW_ENDPOINTS.OAUTH.MICROSOFT.DISCONNECT)
      .then(res => res.data)
}
